<script>
  import { fly, fade, scale, slide } from "svelte/transition";

  let clicked = false;
  function menu() {
    clicked = !clicked;
  }
</script>

<main class="flex justify-between items-center px-12 py-4">
  <div class="font-Sacramento text-4xl font-extrabold">
    <h1>Azar</h1>
  </div>
  {#if clicked}
    <nav
      transition:fly={{ y: -200, duration: 1500 }}
      class={`md:flex justify-center items-center ${
        clicked
          ? "flex absolute z-10 inset-x-0 inset-y-16 min-h-[calc(100%_-_4rem)] text-xl backdrop-blur-sm"
          : "hidden"
      }`}
    >
      <ul
        class="md:flex md:justify-center md:items-center md:space-x-8 md:space-y-0 space-y-12"
      >
        <li class="relative group" on:click={() => (clicked = false)}>
          <a href="/">
            <span>Home</span>
            <span
              class="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 transition-all group-hover:w-full"
            />
          </a>
        </li>
        <li class=" relative group" on:click={() => (clicked = false)}>
          <a href="/portfolio">
            <span>Portfolio</span>
            <span
              class="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 transition-all group-hover:w-full"
            />
          </a>
        </li>
        <li class=" relative group" on:click={() => (clicked = false)}>
          <a href="/resume">
            <span>Resume</span>
            <span
              class="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 transition-all group-hover:w-full"
            />
          </a>
        </li>
        <li class=" relative group" on:click={() => (clicked = false)}>
          <a href="/about">
            <span>About</span>
            <span
              class="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 transition-all group-hover:w-full"
            />
          </a>
        </li>
        <li class=" relative group" on:click={() => (clicked = false)}>
          <a href="/contact">
            <span>Contact</span>
            <span
              class="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 transition-all group-hover:w-full"
            />
          </a>
        </li>
      </ul>
    </nav>
  {:else}
    <nav
      transition:fly={{ y: -200, duration: 1500 }}
      class={`md:flex hidden justify-center items-center`}
    >
      <ul
        class="md:flex md:justify-center md:items-center md:space-x-8 md:space-y-0 space-y-12"
      >
        <li class="relative group">
          <a href="/">
            <span>Home</span>
            <span
              class="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 transition-all group-hover:w-full"
            />
          </a>
        </li>
        <li class=" relative group">
          <a href="/portfolio">
            <span>Portfolio</span>
            <span
              class="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 transition-all group-hover:w-full"
            />
          </a>
        </li>
        <li class=" relative group">
          <a href="/resume">
            <span>Resume</span>
            <span
              class="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 transition-all group-hover:w-full"
            />
          </a>
        </li>
        <li class=" relative group">
          <a href="/about">
            <span>About</span>
            <span
              class="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 transition-all group-hover:w-full"
            />
          </a>
        </li>
        <li class=" relative group">
          <a href="/contact">
            <span>Contact</span>
            <span
              class="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 transition-all group-hover:w-full"
            />
          </a>
        </li>
      </ul>
    </nav>
  {/if}
  <button class={`md:hidden block`} on:click={menu}>
    {#if clicked}
      <i in:fade out:scale class={`fa-solid fa-times text-xl`} />
    {:else}
      <i in:fade out:scale class={`fa-solid fa-bars text-xl`} />
    {/if}
  </button>
</main>
